import { render } from "./TheHeader.vue?vue&type=template&id=d7aad9f8&scoped=true&lang=html"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=d7aad9f8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7aad9f8"]])

export default __exports__